// extracted by mini-css-extract-plugin
export default {"tickbox":"chat_menu-module___tickbox___e59e28d7"};